var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0518 3.61159e-05H3.36982C1.50518 3.61159e-05 0 1.50522 0 3.36985V9.88483C0 11.7495 1.50518 13.2546 3.36982 13.2546H6.58229L8.35698 16.0404C8.53673 16.3325 8.85122 16.5123 9.21071 16.5123C9.54763 16.5123 9.86213 16.3549 10.0419 16.0854L11.8392 13.2548L15.052 13.2546C16.9166 13.2546 18.4218 11.7494 18.4218 9.88479V3.36982C18.4218 1.50518 16.9165 0 15.052 0L15.0518 3.61159e-05ZM15.0518 11.9067H11.4573C11.2551 11.9067 10.9854 12.0191 10.8732 12.2662L9.21075 14.8947L7.52584 12.2212C7.39107 12.0191 7.18892 11.9067 6.96421 11.9067H3.36966C2.24638 11.9067 1.34785 11.0082 1.34785 9.88491V3.36994C1.34785 2.24666 2.24638 1.34813 3.36966 1.34813H15.0517C16.175 1.34813 17.0735 2.24666 17.0735 3.36994V9.88491C17.0737 11.0082 16.1751 11.9067 15.0518 11.9067L15.0518 11.9067Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.2a63956530e2577c9c2c43ce5564c117.svg";
export { ForwardRef as ReactComponent };